import React, { useEffect } from 'react'
import { useAtom } from 'jotai'
import _ from 'lodash'
import { Background, Content } from '@/presentation/components'
import { Image } from './styles'
import Img from '@/presentation/assets/images/home.png'
import { useSelector } from 'react-redux'
import { globalThemeAtom } from 'config/providers/global/globalTheme'

const Home = () => {
  const user = useSelector((state) => state.user?.data)
  const [theme, setTheme] = useAtom(globalThemeAtom)
  useEffect(() => {
    if (Object.keys(JSON.parse(user.resale.theme)).length === 0) {
      setTheme({})
      return
    }
    setTheme(_.merge(theme, JSON.parse(user?.resale?.theme)))
    // eslint-disable-next-line
  }, [])
  return (
    <Background>
      <Content>
        <Image src={Img} />
      </Content>
    </Background>
  )
}

export default Home
